import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Flame } from "lucide-react";
import { useSEO } from "@/lib/useSEO";

export default function PaymentCancel() {
  useSEO({ title: "Donation Cancelled | Neem Karoli Baba Mandir", noindex: true });
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center bg-[#FDFBF7] px-4">
      <div className="max-w-md w-full text-center bg-white border border-amber-900/15 rounded-2xl p-10 shadow-xl shadow-amber-900/5">
        <Flame className="mx-auto h-10 w-10 text-amber-600 mb-4" />
        <h1 className="font-display text-2xl text-amber-950 mb-3" data-testid="payment-cancel-heading">No Charge Was Made</h1>
        <p className="text-stone-600 text-sm mb-6">
          Your donation was not completed and you have not been charged. The door of the Mandir is always open whenever you are ready.
        </p>
        <Link to="/#donate">
          <Button data-testid="try-again-donate-button" className="bg-amber-700 hover:bg-amber-800 text-white rounded-full px-8">
            Return to Donation Seva
          </Button>
        </Link>
      </div>
    </div>
  );
}
